import { AccessPermissions, Role } from '@circlefin/permissions'
import { SynthRole } from '@services/synthetic-roles'

import type { PermissionSet } from '@circlefin/permissions'

/**
 * Permissions for guarding burn fee improvements.
 */
export const BURN_FEE_IMPROVEMENTS: PermissionSet = {
  access: AccessPermissions.protected,
  includeAll: [
    Role.BURN_FEE_HISTORY_ROLE,
    SynthRole.SYNTH_BURN_FEE_IMPROVEMENTS_ENABLE_ROLE,
  ],
}
